import SubArrangementComponent from './SubArrangementComponent.js';
import {
    setArrangementXScale,
} from "actions/index.js";
import {onScale} from './onScale.js';
import {getBarWidth} from './getBarWidth.js';
import {getHeight} from './getHeight.js';
import {connect} from 'react-redux';
import MouseHelper from './MouseHelper.js';
import SelectionComponent from './SelectionComponent.js';
import SelectionBox from './SelectionBox.js';
import {
    NO_SUB_SEQUENCE,
} from 'session/constants.js';
import RollsArrangementComponent from './RollsArrangementComponent.js';
import {getStepFromPosition} from './getStepFromPosition.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ClockTickComponent from './ClockTickComponent.js';
import React, {memo, Component, useCallback, useEffect, useRef} from 'react';
import TimeRowComponent from './TimeRowComponent.js';
    
const SCROLL_BUFFER_LENGTH = 140;

const ArrangementContainer = memo(({
    showTracks,
    onMouseDown,
    onMouseUp,
    onMouseMove,
    sequencerEngine,
    resolution,
    arrangementContainer,
    mixSession,
    totalLength,
    xScale,
    setArrangementXScale,
    yScrollContainer
}) => {
    let ref = useRef(undefined);
    let mouseX = useRef(0);
    let lastCursor = useRef(0);
    let style = {
        height: getHeight(sequencerEngine, showTracks) 
    };

    let width = getBarWidth(16*totalLength, resolution, xScale);

    useEffect(() => {
        ref.current.addEventListener("mousewheel", onMouseWheel, {passive: false});

        return () => ref.current ? ref.current.removeEventListener("mousewheel", onMouseWheel) : 0;
    }, [xScale, resolution, totalLength]);

    const onMouseWheel = useCallback((e) => {
        if (e.ctrlKey) {
            e.preventDefault();
            e.stopPropagation();
            // Your zoom/scale factor
            let _xScale = xScale - e.deltaY * 0.01;
            if (getBarWidth(16*totalLength, resolution, _xScale) < window.innerWidth - 140) {
                // Dont let user zoom out beyond the width of the window
                return;
            }

            onScale({
                x: mouseX.current,
                setArrangementXScale,
                arrangementContainer: ref,
                cursorStep: lastCursor.current, 
                resolution, 
                xScale: _xScale
            });
        } else {
            let width = getBarWidth(1, resolution, xScale);
            let _cursorStep = (e.clientX - SCROLL_BUFFER_LENGTH + ref.current.scrollLeft) / width;
            mouseX.current = e.clientX;
            lastCursor.current = _cursorStep;
        }
    }, [xScale, resolution, totalLength]);

    return (
        <div
          ref={ref}
          style={style}
          className="arrangement-container"
          onMouseDown={(e) => onMouseDown(e)}
          onMouseLeave={() => onMouseUp()}
          onMouseMove={(e) => {
              let width = getBarWidth(1, resolution, xScale);
              let _cursorStep = (e.clientX - SCROLL_BUFFER_LENGTH + ref.current.scrollLeft) / width;
              mouseX.current = e.clientX;
              lastCursor.current = _cursorStep;
              onMouseMove(e);
          }}
          onMouseUp={(e) => onMouseUp(e)}
          >
          <div
            className="viewport-wrapper">
            <ClockTickComponent sequencerEngine={sequencerEngine}/>
          <TimeRowComponent
            height={style.height}
            arrangementContainer={ref}
            yScrollContainer={yScrollContainer}
            sequencerEngine={sequencerEngine}
            selectionStart={undefined}
            selectionEnd={undefined}
            resolution={resolution}
            >
            <SelectionComponent
              arrangementContainer={arrangementContainer}
              sequencerEngine={sequencerEngine}
            />
          </TimeRowComponent>
            <SelectionBox
              arrangementContainer={arrangementContainer}
              sequencerEngine={sequencerEngine}
            />
          <div className="sub-sequence-container">
            {sequencerEngine.subSequences
                .filter(s => !s.isTrack)
                .map(
                (sub, i) =>
                    <SubArrangementComponent
                      key={"sub-arrangement-" + sub.id + '-' + i}
                      i={i}
                      wrapperRef={ref}
                      width={width}
                      sequencerEngine={sequencerEngine}
                      yScrollContainer={yScrollContainer}
                      onMouseUp={e => onMouseUp(e)}
                      subSequence={sub}/>)}
            {sequencerEngine.subSequences
                .filter(s => s.isTrack)
                .map(
                (sub, i) =>
                    <SubArrangementComponent
                      key={"sub-arrangement-" + sub.id}
                      wrapperRef={ref}
                      width={width}
                      yScrollContainer={yScrollContainer}
                      sequencerEngine={sequencerEngine}
                      onMouseUp={e => onMouseUp(e)}
                      subSequence={sub}/>)}
        </div>
            <RollsArrangementComponent
              width={width}
              mixSession={mixSession}
              wrapperRef={ref}
              subSequence={NO_SUB_SEQUENCE}
              sequencerEngine={sequencerEngine}
            />
          <TimeRowComponent
            sequencerEngine={sequencerEngine}
            constantHeight={true}
            yScrollContainer={yScrollContainer}
            arrangementContainer={ref}
            isBottom={true}
            selectionStart={undefined}
            selectionEnd={undefined}
            resolution={resolution}
            />
           <div className="arrangement-rest"/>
            </div>
          </div>
    );
});

const mapStateToProps = (state, props) => {
    return {
        showTracks: state.arrangement.showTracks,
        totalLength: state.arrangement.totalLength,
        xScale: state.arrangement.xScale,
        numTracks: props.sequencerEngine.tracks && props.sequencerEngine.tracks.length
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setArrangementXScale: (xScale) => dispatch(
            setArrangementXScale(xScale))
    }
};
 

export default connect(mapStateToProps, mapDispatchToProps)(ArrangementContainer);
